// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"ddef0da3","208":"e4ca53bd","462":"a20d8082","480":"45068fd0","688":"57eb0a19","820":"555ca473","825":"e0c972f3","841":"de331f44","985":"71646035"}[chunkId] + ".chunk.css";
};